// extracted by mini-css-extract-plugin
module.exports = {"container":"layout_container__vgwhE","ios-container":"layout_ios-container__cFVJP","main":"layout_main__euHB3"};